import { CircularProgress } from '@mui/material'
import useStyles from './style'
const Loading = () => {
  const classes = useStyles()
  return <CircularProgress color="primary" className={classes.loading} />
}

export default Loading
